import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import red from "@material-ui/core/colors/red";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Alert from "@material-ui/lab/Alert";
import { API_BASE_URL } from "../../constants";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { withRouter } from "react-router-dom";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        SML Group Limited
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const AccountApproved = (props) => {
  let { emailId } = useParams();

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) {
      props.history.push("/SignIn");
    } else {
      getUserDetails();
    }
  }, []);

  const getUserDetails = async () => {
    const access_token = localStorage.getItem("access_token");
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    console.log("authUser");
    await axios
      .get(API_BASE_URL + "users/get-user-details/" + authUser.email, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        //valid user token
      })
      .catch((error) => {
        //invalid user token
        localStorage.removeItem("access_token");
        localStorage.removeItem("authUser");
        props.history.push("/SignIn");
      });
  };

  const handleSubmit = async (data) => {
    const access_token = localStorage.getItem("access_token");
    if (!emailId) {
      setError(true);
      setMessage("Email required");
    } else {
      setIsLoading(true);
      await axios
        .patch(API_BASE_URL + "approve-reject-request", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        })
        .then((response) => {
          if (response.data.httpStatus === "ALREADY_REPORTED") {
            setIsLoading(false);
            setError(true);
            setMessage(response.data.message);
            setTimeout(() => {
              setError(false);
              setMessage("");
            }, 4000);
          } else {
            setIsLoading(false);
            setSuccess(true);
            setMessage(response.data);

            setTimeout(() => {
              setSuccess(false);
              setMessage("");
            }, 4000);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          if (
            error &&
            error.response &&
            error.response.data.httpStatus === "NOT_FOUND"
          ) {
            setIsLoading(false);
            setError(true);
            setMessage(error.response.data.message);
            setTimeout(() => {
              setError(false);
              setMessage("");
            }, 4000);
          }
          console.log("error", error);
          console.log("error", error.response);
        });
    }
  };

  const handleLogOut = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("authUser");
    props.history.push("/SignIn");
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        {success && message && (
          <div style={{ margin: 16 }}>
            <Alert severity="success">{message} </Alert>
          </div>
        )}

        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Account Approval
        </Typography>
        <form
          className={classes.form}
          onSubmit={(e) => e.preventDefault()}
          noValidate
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                value={emailId}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() =>
                  handleSubmit({
                    email: emailId,
                    userStatus: "Active",
                    requestStatus: "Approved",
                  })
                }
              >
                Approve
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() =>
                  handleSubmit({
                    email: emailId,
                    userStatus: "Inactive",
                    requestStatus: "Reject",
                  })
                }
              >
                Reject
              </Button>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => handleLogOut()}
              >
                LOGOUT
              </Button>
            </Grid>
          </Grid>
          {isLoading ? (
            <Grid item xs={12}>
              <div className={classes.loader}>
                <CircularProgress color="secondary" />
              </div>
            </Grid>
          ) : null}

          {error && message && (
            <div style={{ margin: 16 }}>
              <Alert severity="error">{message} </Alert>
            </div>
          )}
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: red[400],
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: red[400],
    "&:hover": {
      backgroundColor: red[200],
    },
  },
  reject: {
    margin: theme.spacing(3, 0, 2),
  },
  loader: {
    margin: 16,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
}));

export default withRouter(AccountApproved);
